import React, { Component } from 'react';
import { Button, Form, Input, InputNumber, Row, Col, message, DatePicker, Icon, Upload} from 'antd';
import './css/style.css';
import logo from './img/logo.png';
import gql from 'graphql-tag'
import loadImage from 'blueimp-load-image'
import { withRouter } from 'react-router-dom'
import { graphql, compose, withApollo } from 'react-apollo'
import {HeaderContainer, BoxContainer, Channel} from '../pages/styled-components/index';
const FormItem = Form.Item;
const { TextArea } = Input;
const RangePicker = DatePicker.RangePicker;

const fileData = (url = '') => {
    const matches = url.match(/^data:(.+);base64,(.*)$/)
    if (!matches) {
      return null
    }
    const [, mimeType, base64data] = matches
    return {
      mimeType,
      base64data
    }
  }
// const MAX_DIMENSION = 1800

class CreateEvent extends Component {
    state = {
        loading: false,
        visible: false,
        slugData: ''
      }
    
    handleslugChange = (e) => {
        // console.log(e.target.value)
        this.setState({
           slugData: e.target.value
        })
    }

    beforeUpload = (file, files) => {
        loadImage(file, canvas => {
          const imgUrl = canvas.toDataURL('image/jpeg', 0.95)
          file.thumbUrl = imgUrl
          this.props.form.setFieldsValue({
            file
          })
        }, {
        //   maxWidth: MAX_DIMENSION,
        //   maxHeight: MAX_DIMENSION,
          contain: true,
          orientation: true,
          canvas: true
        })
        return false
    }    

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        this.props.form.validateFields((err, values) => {
          if (err) {
            this.setState({ loading: false })
            console.error(err)
            return
          }
          const { slug, title, file, dateRange, donateTops, donationBykilo, donationAllshirt, maximumDistance, content, modalContent } = values

          const [startDate, endDate] = dateRange

          this.props.addEvent({
            variables: {
                record: {
                    slug,
                    title,          
                    donateTops,              
                    donationBykilo,              
                    donationAllshirt,              
                    maximumDistance,              
                    content,             
                    startDate,              
                    endDate,           
                    modalContent     
                },
                file: (file && file.thumbUrl) ? fileData(values.file.thumbUrl) : null
              },
            }).then(res => {
                message.success('Create Event of success');
                setTimeout(function(){ window.location.href=`/event`}, 1000);
                // this.props.history.push(`/`)
            })
        });
      } 
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const rangeConfig = {
            rules: [{ type: 'array', required: true, message: 'Please select time!' }],
        };
        const slugConfig ={
            rules: [{ required: true, message: 'Please input the slug of Event!'}],
        };
        const titleConfig ={
            rules: [{ required: true, message: 'Please input the title of Event!'}],
        };
        const fileDecorator = getFieldDecorator('file', {
            rules: [{ 
              required: true, 
              message: 'Please input your image!',
            }]
        })
        const file = getFieldValue('file')
        const fileProps = {
        accept:'.png, .jpeg, .jpg, .PNG, .JPEG, .JPG',
        action: '',
        showUploadList: false,
        fileList: file ? [file] : [],
        beforeUpload: this.beforeUpload
        }
        const formItemLayout = {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 10 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 14 },
            },
          };
        return (
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col style={{marginTop:'100px'}} /> 
                    <Col className="header">
                        <HeaderContainer>
                            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-start'}}>
                                <img src={logo} alt="logo" />
                                <a href="/event" className='backhome'>
                                  <strong>Event</strong>
                                </a>
                                <a href="/comprehendEvent" className='backhome'>
                                  <strong>Report</strong>
                                </a>
                            </div>
                        </HeaderContainer>   
                    </Col>
                </Row>
                <BoxContainer>
                    <Channel>
                        <FormItem hasFeedback {...formItemLayout} label="Event title">
                            {getFieldDecorator('title', titleConfig)(
                                <Input
                                  onChange={this.handleslugChange}
                                />
                            )}
                        </FormItem>
                        <FormItem hasFeedback {...formItemLayout} label="Slug">
                            {getFieldDecorator('slug', slugConfig)(
                                <Input
                                  onChange={this.handleslugChange}
                                />
                            )}
                        </FormItem>
                        <FormItem hasFeedback {...formItemLayout} label="วัน/เวลาเปิด-ปิดการส่งผล">
                            {getFieldDecorator('dateRange', rangeConfig)(
                                <RangePicker showTime format="YYYY-MM-DD HH:mm:ss" />
                            )}
                        </FormItem>

                        <FormItem hasFeedback {...formItemLayout} label="กราฟฟิกรูปภาพ Event">
                            {fileDecorator(<Upload {...fileProps}>
                                {file ?
                                    <div style={{display:'flex', alignItems:'center'}}>
                                        <img style={{width:'150px',paddingRight:'10px'}} src={file.thumbUrl} alt=""/> 
                                        <Button style={{marginLeft:'10px'}}> แก้ไข </Button>
                                    </div>: 
                                    <Button><Icon type="upload" /> Click to Upload</Button>
                                }
                            </Upload>)}
                        </FormItem> 



                        <FormItem 
                            hasFeedback
                            {...formItemLayout}
                            label="ยอดบริจาคเสื้อ 1 ตัว (บาท)"
                        >
                        {getFieldDecorator('donateTops')(
                            <InputNumber style={{width:'50%'}}/>
                        )}
                        </FormItem>
                        <FormItem 
                            hasFeedback
                            {...formItemLayout}
                            label="ยอดบริจาคจากการขายเสื้อ (บาท)"
                        >
                        {getFieldDecorator('donationAllshirt')(
                            <InputNumber style={{width:'50%'}}/>
                        )}
                        </FormItem>
                        <FormItem 
                            hasFeedback
                            {...formItemLayout}
                            label="ยอดบริจาคแต่ละกิโลเมตร (บาท)"
                        >
                        {getFieldDecorator('donationBykilo')(
                            <InputNumber style={{width:'50%'}}/>
                        )}
                        </FormItem>
                        <FormItem 
                            hasFeedback 
                            {...formItemLayout}
                            label="ยอดบริจาคไม่เกินต่อkm.(บาท)"
                        >
                        {getFieldDecorator('maximumDistance')(
                            <InputNumber style={{width:'50%'}}/>
                        )}
                        </FormItem>
                        <FormItem 
                            hasFeedback 
                            {...formItemLayout} 
                            label="Content">
                            {getFieldDecorator('content')(
                                <TextArea autosize={{ minRows: 2, maxRows: 6 }} />
                            )}
                        </FormItem>
                        <FormItem 
                            hasFeedback 
                            {...formItemLayout} 
                            label="Content - Ecer">
                            {getFieldDecorator('modalContent')(
                                <TextArea autosize={{ minRows: 2, maxRows: 6 }} />
                            )}
                        </FormItem>
                        <FormItem >
                            <Button type="primary" htmlType="submit" loading={this.state.loading} ><Icon type="save"/>Create</Button>
                        </FormItem> 
                    </Channel>
                </BoxContainer>
            </Form>
    );
  }
}
// const WrappedNormalLoginForm = Form.create()(NormalLoginForm);

const addEventMutation = gql`
mutation addEvent($record: CreateOneEventInput! ,$file: Base64FileInput){
	addEvent(record: $record ,file: $file) {
    record {
      _id
      slug
      title
      startDate              
      endDate
      donateTops                            
      donationBykilo              
      maximumDistance              
      donationAllshirt              
      targetedAmount          
      content             
      modalContent              
    }
    recordId
  }
}`

export default 
    compose(
    withApollo,
    withRouter,
    Form.create() ,
        graphql(addEventMutation,{
            name: 'addEvent'
        },
    ),
    )(CreateEvent);

  


// WEBPACK FOOTER //
// ./src/components/pages/createEvent.js